import i18n from "i18next";

const NUMBER_LOCALES: Record<string, string> = {
  en: "en-US",
  ar: "ar-EG",
};

const getNumberLocale = () => NUMBER_LOCALES[i18n.language] ?? "en-US";

const formatNumber = (number?: number, locale?: string) => {
  if (typeof number !== "number" || Number.isNaN(number)) return NaN;
  return number.toLocaleString(locale ?? getNumberLocale());
};

const compactFormatters = new Map<string, Intl.NumberFormat>();

const compactNumber = (value: number, locale?: string) => {
  const key = locale ?? getNumberLocale();
  let formatter = compactFormatters.get(key);
  if (!formatter) {
    formatter = new Intl.NumberFormat(key, {
      notation: "compact",
      compactDisplay: "short",
      roundingMode:"floor",
    });
    compactFormatters.set(key, formatter);
  }
  return formatter.format(value);
};

const padNumber = (n: number, fullLength: number, locale?: string) =>
  new Intl.NumberFormat(locale ?? getNumberLocale(), { minimumIntegerDigits: fullLength, useGrouping: false }).format(n);

export { compactNumber, formatNumber, getNumberLocale, padNumber };
